import { z } from 'zod';
import { defineFeature } from '../core/defineFeature.js';
import { FeatureType } from '../core/types.js';
/**
 * Settings of the application as a whole: how it is titled and where it lands. Application-scoped
 * and not specific to chat, the navbar or another module; put those in their own category.
 * Keeps id 6 from the former "Tab Configuration" category.
 */
const ApplicationSettings = { id: 6, name: 'Application Settings' };
export const browserTabName = defineFeature({
    type: FeatureType.String,
    propName: 'browser_tab_name',
    uiName: 'browserTabName',
    displayName: 'Browser Tab Name',
    description: 'Configure browser tab name',
    category: ApplicationSettings,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: '',
    isSystem: true,
    flatModelSchema: z.string().nullable(),
});
export const homeScreen = defineFeature({
    type: FeatureType.String,
    propName: 'home_screen',
    uiName: 'homeScreen',
    displayName: 'Home Page',
    description: 'Home page for the application',
    category: ApplicationSettings,
    areas: ['application'],
    codec: 'identity',
    schema: z.string(),
    default: 'chat',
    validValues: ['chat', 'workspace', 'analyst-main'],
    isSystem: true,
    flatModelSchema: z.enum(['chat', 'workspace', 'analyst-main']).nullable(),
});
export const useNewExperience = defineFeature({
    type: FeatureType.Boolean,
    propName: 'use_new_experience',
    uiName: 'useNewExperience',
    displayName: 'Use New Experience',
    description: 'Enable the redesigned landing page experience for this application',
    category: ApplicationSettings,
    areas: ['application'],
    surfacedIn: ['application'],
    codec: 'identity',
    schema: z.boolean(),
    default: true,
    isSystem: true,
});
export const applicationSettingsFeatures = [browserTabName, homeScreen, useNewExperience];
